<template>
  <div class="main-content-container container-fluid px-4">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :loader="'dots'"
      :height="150"
      :width="150"
      :color="'#F1557A'"
      :is-full-page="fullPage"
    ></loading>
    <v-dialog />
    <!-- Page Header -->

    <div class="page-header row no-gutters py-4">
      <div class="col-lg-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Supporters</h3>
      </div>
      <div class="col-lg-4 col-sm-4 mb-0">
        <d-button class="btn-blue btn-right" @click="openModal">
          <i class="material-icons">add</i> Create To Do
        </d-button>
      </div>
    </div>
    <sweet-modal ref="modal">
      <strong class="text-muted text-left d-block mb-2">Select a User</strong>
      <d-input-group class="mb-3">
        <d-select @change="onchangesupporter" :required="true">
          <option default>Select</option>
          <option
            v-for="(employee, index) in allEmployees"
            :key="index"
            v-bind:value="employee._id"
            >{{ employee.first_name + " " + employee.last_name }}</option
          >
        </d-select>
      </d-input-group>
      <strong class="text-muted text-left d-block mb-2"
        >Select a Call-To-Action</strong
      >
      <d-input-group class="mb-3">
        <d-select @change="onchangeCta" :required="true">
          <option default>Support our new campaign - One-Time Donation</option>
          <option
            v-if="allCTA.length > 0"
            v-for="(cta, index) in allCTA"
            :key="index"
            v-bind:value="cta.id"
            >{{ cta.title + " - " + cta.type }}</option
          >
        </d-select>
      </d-input-group>
      <br />
      <br />
      <d-button @click.prevent="assignTodo()" class="btn-blue btn-right"
        >Assign</d-button
      >
    </sweet-modal>
    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <vue-good-table
            class="card-style"
            :columns="columns"
            :rows="rows"
            @on-row-click="onRowClick"
            @on-select-all="onSelectAll"
            styleClass="vgt-table striped condensed"
            :search-options="{
              enabled: true,
              skipDiacritics: true,
              // searchFn: mySearchFn,
              placeholder: 'Search your base',
              externalQuery: searchQuery
            }"
            :sort-options="{
              enabled: true,
              initialSortBy: [{ field: 'createdAt', type: 'asc' }]
            }"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 25,
              position: 'top',
              perPageDropdown: [25, 50, 100],
              dropdownAllowAll: false,
              setCurrentPage: 2,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'Supporters per page',
              ofLabel: 'of',
              pageLabel: 'page', // for 'pages' mode
              allLabel: 'All'
            }"
            :selectOptions="{
              enabled: true,
              selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: false // disable the select info panel on top
            }"
          />
        </div>
        <d-col class="text-right view-report" style="margin-botton:15px;">
          <download-csv :data="supporters" name="givemagic_export.csv">
            <p class="explainer">
              To access your supporters email & phone number, please download a
              csv
            </p>
            <a href="#">Export csv report</a>
          </download-csv>
        </d-col>
      </div>
    </div>
  </div>
</template>
<script>
import supportersTypes from "../vuex/supporters/supporters.types";
import TodoTypes from "../vuex/todos/todos.types";
import ctaTypes from "../vuex/cta/cta.types";
import managerTypes from "../vuex/manager/manager.types";
import DownloadCsv from "vue-json-csv";
import moment from "moment";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import "quill/dist/quill.snow.css";
Vue.use(Loading);

import { mapState } from "vuex";
export default {
  data() {
    return {
      isLoading: false,
      supporters: [],
      allCTA: [],
      allEmployees: [],
      selectedEmployee: {},
      selectedSupporters: [],
      selectedCTA: null,
      fullPage: true,
      selectedUser: null,
      columns: [
        {
          label: "First Name",
          field: "first_name"
        },
        {
          label: "Last Name",
          field: "last_name"
        },
        {
          label: "Email",
          field: "email",
          type: "text",
          hidden: true
        },
        {
          label: "Phone Number",
          field: "phone_number",
          type: "text",
          hidden: true
        },
        {
          label: "Donor Type",
          field: "gm_donor_type",
          // html: true
        },
        {
          label: "Total Donated",
          field: "amount_donated",
          // formatFn: this.formatFn
        },
        {
          label: "Videos Opened",
          field: "video_viewed"
        },
        {
          label: "Play Rate",
          field: "watch_rate"
        },
        {
          label: "Last Video",
          field: "last_sent"
        },
        {
          label: "Last Donate",
          field: "last_donate"
        },
        {
          label: "Custom Text Field",
          field: "custom_text",
           hidden: true
        },
        {
          label: "Created Date CRM",
          field: "createdAt",
          // type: "date",
          //  type: "text"
          // dateInputFormat: "yyyy-MM-dd",
          // dateOutputFormat: "MMM Do yy"
        },
        {
          label: "Supporter Source",
          field: "supporter_source",
          type: "text",
           hidden: true
        }
      ],
      rows: [
        // { id:1, first_name:"John", last_name:"John", email:"mwarshafsky@gmail.com", phone_number:"647-822-8757", donor_type: "lapsed", total_donated: 50,createdAt: '2011-10-31', source: 'www.givemagic.co' },
        // { id:2, first_name:"John", last_name:"John", email:"mwarshafsky@gmail.com", phone_number:"647-822-8757", donor_type: "one-time", total_donated: 51,createdAt: '2011-10-31', source: 'www.givemagic.co' },
        // { id:3, first_name:"John", last_name:"John", email:"mwarshafsky@gmail.com", phone_number:"647-822-8757", donor_type: "monthly", total_donated: 52,createdAt: '2011-10-31', source: 'www.givemagic.co' },
        // { id:4, first_name:"John", last_name:"John", email:"mwarshafsky@gmail.com", phone_number:"647-822-8757", donor_type: "lapsed", total_donated: 53,createdAt: '2011-10-31', source: 'www.givemagic.co' },
        // { id:5, first_name:"John", last_name:"John", email:"mwarshafsky@gmail.com", phone_number:"647-822-8757", donor_type: "lapsed", total_donated: 54,createdAt: '2011-10-31', source: 'www.givemagic.co' },
        // { id:6, first_name:"John", last_name:"John", email:"mwarshafsky@gmail.com", phone_number:"647-822-8757", donor_type: "lapsed", total_donated: 55,createdAt: '2011-10-31', source: 'www.givemagic.co' },
      ],
      userColumns: [
        {
          label: "First Name",
          field: "first_name"
        },
        {
          label: "Last Name",
          field: "last_name"
        }
      ],
      userRows: [
        { first_name: "John", last_name: "Smith" },
        { first_name: "Jack", last_name: "Ryan" }
      ]
    };
  },
  computed: {
    ...mapState({
      state: state => state.supporters.state,
      type: state => state.supporters.type,
      data: state => state.supporters.data,
      employees: state => state.manager.data,
      managerType: state => state.manager.type,
      ctas: state => state.cta.data,
      ctaType: state => state.cta.type,
      error: state => state.supporters.error,
      todoType: state => state.todos.type,
      todoerror: state => state.todos.error
    })
  },
  methods: {
    openModal() {
      this.$refs.modal.open();
      analytics.track("Clicked Create To Do");
    },
    closeModal() {
      this.$refs.modal.close();
    },
    onRowClick(row) {
      if (row.selected) {
        this.selectedSupporters.push(row.row._id);
      } else {
        const index = this.selectedSupporters.indexOf(row.row._id);
        if (index != -1) {
          this.selectedSupporters.splice(index, 1);
        }
      }
    },
    onSelectAll(selectAll) {
      if (selectAll.selected) {
        selectAll.selectedRows.map(item => {
          this.selectedSupporters.push(item._id);
        });
      } else {
        this.selectedSupporters = [];
      }
    },
    onchangesupporter(supporter) {
      if (supporter != "Select") {
        this.selectedUser = supporter;
      } else this.selectedUser = null;
    },
    onchangeCta(cta) {
      this.selectedCTA = cta;
    },
    formatFn: function(value) {
      return "$" + value;
    },
    csvFieds(value, key) {
    },
    dateFormat(value) {
      return moment(String(value)).format("MM/DD/YYYY hh:mm");
    },
    assignTodo() {
      if (!this.selectedSupporters || !this.selectedSupporters.length) {
        alert("Please Select Supporters First");
      } else if (!this.selectedUser) {
        alert("Please Select User");
      } else if (
        !this.selectedCTA ||
        this.selectedCTA == "Support our new campaign - One-Time Donation"
      ) {
        alert("Please Select CTA");
      } else {
        this.closeModal();
        var obj = {
          supporters: this.selectedSupporters,
          cta: this.selectedCTA,
          employee: this.selectedUser
        };
        this.$store.dispatch("assignTodo", obj);
        analytics.track("Created To Do");
      }
    },
    deletesupporter(supporter) {
      const modal = this.$modal;
      const that = this;
      modal.show("dialog", {
        title: "Confirm delete",
        text: "Are you sure you want to delete this supporter?",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              modal.hide("dialog");
            }
          },
          {
            title: "Delete",
            handler: () => {
              that.$store.dispatch("deletesupporter", supporter);
              modal.hide("dialog");
            },
            class: "vue-dialog-button delete-btn"
          }
        ]
      });
    }
  },
  watch: {
    ctaType(type) {
      if (type == ctaTypes.FETCH_CTAS_SUCCESS) {
        var sortDAta = []
        this.ctas.actions.map((item,index)=>{
         if(!item.archived){
          sortDAta.push(item)
          }
        })
        this.allCTA = sortDAta;
      }
    },
    todoType(type) {
      if (type === TodoTypes.ADD_TODOS_REQUEST) {
        this.isLoading = true;
        // this.$toasted.info("Assigning Todo...", {
        //   icon: "hourglass_empty",
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
      } else if (type === TodoTypes.ADD_TODOS_SUCCESS) {
        this.isLoading = false;
        this.$toasted.success("Todo assigned successfully", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (type === TodoTypes.ADD_TODOS_FAILED) {
        this.isLoading = false;
        this.$toasted.error(this.todoerror, {
          icon: "error_outline",
          //duration: 1000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    },
    managerType(type) {
      if (type === managerTypes.FETCH_manager_SUCCESS) {
        this.allEmployees = this.employees.employees;
      }
    },
    type(newType) {
      if (newType === supportersTypes.FETCH_supporterS_SUCCESS) {
       var data = this.data.supporters
       var supporterArray = [];
       data.map((item,index)=>{
         var calculation = item.video_viewed  / item.page_viewed
         var result = calculation*100
         var obj = {
            first_name : item.first_name,
            last_name:  item.last_name,
            gm_donor_type: item.gm_donor_type,
            amount_donated: `$${item.amount_donated}`,
            video_viewed: item.video_viewed,
            watch_rate: !result ? `${0}%` : `${Math.round(result)}%`,
            last_sent: !item.last_video_received ?'-': moment(item.last_video_received).format("MM/DD/YYYY hh:mm") ,
            last_donate:!item.last_donation_date ? '-' : moment(item.last_donation_date).format("MM/DD/YYYY hh:mm") ,
            custom_text:!item.custom_text_field ? '-' :item.custom_text_field ,
            supporter_source:!item.supporter_source? '-' :item.supporter_source,
            createdAt: moment(item.createdAt).format("MM/DD/YYYY hh:mm"),
            _id: item._id
          }
          supporterArray.push(obj)
       })

        this.rows = supporterArray;
        this.isLoading = false;
      } else if (newType === supportersTypes.DELETE_supporter_SUCCESS) {
        this.isLoading = false;
        this.$toasted.success("supporter deleted", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
        //window.location.reload();
      } else if (newType === supportersTypes.FETCH_supporterS_REQUEST) {
        this.isLoading = true;
        // this.$toasted.info("Fetching supporters...", {
        //   icon: "hourglass_empty",
        //   duration: 1000,
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
      } else if (newType === supportersTypes.DELETE_supporter_REQUEST) {
        this.isLoading = true;
        // this.$toasted.info("Deleting supporter...", {
        //   icon: "hourglass_empty",
        //   duration: 1000,
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
      } else if (newType === supportersTypes.FETCH_supporterS_FAILED) {
        this.isLoading = false;
        this.$toasted.error(this.error, {
          icon: "error_outline",
          //duration: 1000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (newType === supportersTypes.DELETE_supporter_FAILED) {
        this.isLoading = false;
        this.$modal.hide("dialog");
        this.$toasted.error(this.error, {
          icon: "error_outline",
          //duration: 1000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    }
  },
  components: {
    DownloadCsv,
    VueGoodTable,
    SweetModal,
    SweetModalTab,
    Loading
  },
  created() {
    this.$store.dispatch("fetchsupporters");
    this.$store.dispatch("fetchAllCTA");
    this.$store.dispatch("fetchAllEmployees");
    analytics.page("Supporters");
  }
};
</script>
<style lang="scss">
.btn-right {
  width: 175px !important;
  height: 50px;
  float: right;
  font-size: 16px;
}
.vue-dialog-button.delete-btn {
  background: #dd4b44;
  color: white;

  &:hover {
    background: #de3b34;
  }
}
</style>
<style scoped lang="scss">
.profile-pic {
  max-width: 50px;
  max-height: 50px;
  border-radius: 5px;
}

table td {
  font-size: 12px;
}
td,
th {
  padding: 0.125em 0.5em 0.25em 0.5em;
  line-height: 1.2;
}
th {
  padding: 0.75rem;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
.fig-table {
  max-width: 100%;
  overflow-x: scroll;
}
.table td {
  text-align: center;
  vertical-align: middle;

  .material-icons {
    font-size: 1rem;
    cursor: pointer;
  }

  .edit-icon {
    color: royalblue;
  }
  .delete-icon-wrapper {
    margin-left: 10px;
    .delete-icon {
      color: red;
    }
  }
}
.table thead th {
  text-align: left;
  vertical-align: middle;
}
</style>
